import { BUTTON_SIZE, BUTTON_TYPE, DSButton, DSTooltip } from '@repo/design-system/index'
import React from 'react'
import 'react-reflex/styles.css'
import { useEventTracking } from '../../../../helpers/gtmHelper'
import { n_lesson_prep } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'

interface ICompletePreparationTooltip {
  questionCnt: any
  tooltipContent: any
  onClickButton: any
  showTooltip: any
  setShowTooltip: any
  disabled: any
}

const CompletePreparationTooltip = React.memo(
  ({
    questionCnt,
    tooltipContent,
    onClickButton,
    showTooltip,
    setShowTooltip,
    disabled,
  }: ICompletePreparationTooltip) => {
    const { t } = useTranslation()
    const { sendClickEvent } = useEventTracking()

    return (
      <div className="relative flex">
        {showTooltip ? (
          <DSTooltip
            place="bottom"
            triggerComponent={
              <DSButton
                disabled={disabled}
                onClick={() => {
                  sendClickEvent({
                    button_name: 'lesson_prep_complete',
                  })
                  onClickButton()
                }}
                type={BUTTON_TYPE.SOLID}
                size={BUTTON_SIZE.SM}
              >
                <DSButton.Label>{t(n_lesson_prep.complete.title)}</DSButton.Label>
              </DSButton>
            }
            isMultiline={false}
            contentComponent={tooltipContent}
            hasCloseButton
            onClose={() => setShowTooltip(false)}
          />
        ) : (
          <DSButton
            disabled={disabled}
            onClick={() => {
              sendClickEvent({
                button_name: 'lesson_prep_complete',
              })
              onClickButton()
            }}
            type={BUTTON_TYPE.SOLID}
            size={BUTTON_SIZE.SM}
          >
            <DSButton.Label>{t(n_lesson_prep.complete.title)}</DSButton.Label>
          </DSButton>
        )}
      </div>
    )
  }
)

CompletePreparationTooltip.displayName = 'CompletePreparationTooltip'

export default CompletePreparationTooltip
